var map = {
	"./celo-wallet.webp": 13014,
	"./celo.webp": 60082,
	"./libera.webp": 71191,
	"./metamask.webp": 85109,
	"./valora.webp": 5873,
	"./wallet-connect.webp": 98148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31220;